/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { apiUrl, adminlimit } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import { encodeValue, removeItem, showPriceValue } from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var moduleLink = "/masterpanel/commission/";
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      clientList: [],
      loading: true,
    };
  }
  componentDidMount() {
    var params = {
      params: "limit=" + adminlimit + "&offset=1",
      url: apiUrl + "company",
      type: "master",
    };
    this.props.getListData(params);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.clientyList !== this.state.clientyList) {
      this.setState({
        clientList: nextProps.clientyList,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          var params = {
            params: "limit=" + adminlimit + "&offset=" + value,
            url: apiUrl + "commission/adminlist",
            type: "master",
          };
          this.props.getListData(params);
        }
      );
    }
  };

  removeItem(CompnayId) {
    removeItem(CompnayId);
  }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"commission"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-7 col-md-6">
                    <h4 className="fw-bold">Commission</h4>
                  </div>
                  <div className="col-lg-5 col-md-6 text-end">
                    <Link to={`${moduleLink}adddebit`}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Add Debit
                      </button>
                    </Link>
                    <Link to={`${moduleLink}credit-history`}>
                      <button type="button" className="btn btn-outline-primary waves-effect m-2">
                        View Credit
                      </button>
                    </Link>
                    <Link to={`${moduleLink}debit-history`}>
                      <button type="button" className="btn btn-outline-primary waves-effect m-2">
                        View Debit
                      </button>
                    </Link>
                  </div>
                </div>

                <div className="card">
                  <div className="p-1 mt-4">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Client Name</th>
                          <th>Email</th>
                          <th>Type Of Merchants</th>
                          <th>Balance Commission</th>
                          <th>Total Commission</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={7} align="center">
                              <div className="spinner-border spinner-border-lg text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          this.state.clientList.length > 0 &&
                          this.state.clientList.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <strong>{item.companyName || ""}</strong>
                                </td>
                                <td>
                                  <a href={"mailto:" + item.companyEmail || ""}>{item.companyEmail || ""}</a>
                                </td>
                                <td>
                                  {item.companyMerchantsType === 1 && "Complete"}
                                  {item.companyMerchantsType === 2 && "Voucher Only"}
                                </td>
                                <td>{showPriceValue(item.companyCommissionBalance)}</td>
                                <td>{showPriceValue(item.companyTotalCommissionRevenue)}</td>
                                <td>
                                  <div className="dropdown">
                                    <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                                      <i className="mdi mdi-dots-horizontal"></i>
                                    </button>
                                    <div className="dropdown-menu">
                                      <Link to={`${moduleLink}adddebit/${encodeValue(item._id)}`} className="dropdown-item">
                                        <i className="mdi mdi-pencil-outline me-1"></i>
                                        Add Debit
                                      </Link>
                                      <Link to={`${moduleLink}credit-history/${encodeValue(item._id)}`} className="dropdown-item">
                                        <i className="mdi mdi-eye-arrow-right-outline me-1"></i>
                                        Credit Histroy
                                      </Link>
                                      <Link to={`${moduleLink}debit-history/${encodeValue(item._id)}`} className="dropdown-item">
                                        <i className="mdi mdi-eye-arrow-right-outline me-1"></i>
                                        Debit Histroy
                                      </Link>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var clientList = Array();
  var clientListStatus = "";
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    clientListStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      clientList = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    clientyList: clientList,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
